"use strict";

var _objectSpread = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var mobx_react_1 = require("mobx-react");
// icons
var Menu_1 = __importDefault(require("@mui/icons-material/Menu"));
var ArrowDownward_1 = __importDefault(require("@mui/icons-material/ArrowDownward"));
var ArrowUpward_1 = __importDefault(require("@mui/icons-material/ArrowUpward"));
// locals
var util_1 = require("../util");
var Menu_2 = __importDefault(require("./Menu"));
var ViewMenu = (0, mobx_react_1.observer)(function (_ref) {
  var model = _ref.model,
    IconButtonProps = _ref.IconButtonProps,
    IconProps = _ref.IconProps;
  var _ref2 = (0, react_1.useState)(),
    _ref3 = _slicedToArray(_ref2, 2),
    anchorEl = _ref3[0],
    setAnchorEl = _ref3[1];
  var menuItems = model.menuItems;
  var session = (0, util_1.getSession)(model);
  var items = [].concat(_toConsumableArray(session.views.length > 1 ? [{
    label: 'Move view up',
    icon: ArrowUpward_1.default,
    onClick: function onClick() {
      return session.moveViewUp(model.id);
    }
  }, {
    label: 'Move view down',
    icon: ArrowDownward_1.default,
    onClick: function onClick() {
      return session.moveViewDown(model.id);
    }
  }] : []), _toConsumableArray((typeof menuItems === 'function' ? menuItems() : menuItems) || []));
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(material_1.IconButton, _objectSpread({}, IconButtonProps, {
    onClick: function onClick(event) {
      return setAnchorEl(event.currentTarget);
    },
    "data-testid": "view_menu_icon"
  }), react_1.default.createElement(Menu_1.default, _objectSpread({}, IconProps, {
    fontSize: "small"
  }))), react_1.default.createElement(Menu_2.default, {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onMenuItemClick: function onMenuItemClick(_event, callback) {
      callback();
      setAnchorEl(undefined);
    },
    onClose: function onClose() {
      return setAnchorEl(undefined);
    },
    menuItems: items
  }));
});
exports.default = ViewMenu;